import styled from 'styled-components';

const Container = styled.div`
  min-height: 20px;
`;

export default Container;
